export const GET_RATING_DASHBOARD = "GET_RATING_DASHBOARD";
export const GET_RATING_DASHBOARD_SUCCESS = "GET_RATING_DASHBOARD_SUCCESS";
export const GET_RATING_DASHBOARD_FAIL = "GET_RATING_DASHBOARD_FAIL";
